import categoriesService from '/src/features/applications/categories/api/categories-service';
import { getApplicationsList } from '/src/common/apis/list-services';
import solutionCategoriesService from '/src/features/applications/solution-categories/api/solution-categories-service';

/**
 * @module store/admin/applications/actions
 */
/**
 * Fetch list of categories.
 * @returns {array} List of all categories.
 */
export async function getCategoryList({ commit }) {
  const categoryList = await categoriesService.getCategoriesList();
  commit('setCategoryList', categoryList);
}

/**
 * Fetch list of applications.
 * @returns {array} List of all applications.
 */
export async function getApplicationList({ commit }) {
  const applicationsList = await getApplicationsList(true);
  commit('setApplicationsList', applicationsList);
}

/**
 * Fetch list of solution categories.
 * @returns {array} List of all solution categories.
 */
export async function fetchSolutionCategoriesList({ commit }) {
  const solutionList = await solutionCategoriesService.getSolutionCategoriesList();
  commit('setSolutionCategoriesList', solutionList);
}
